import React, { useEffect } from 'react'
import DocumentTitle from 'react-document-title'
import { useChatWidgetContext } from 'utils/context/ChatWidgetContext'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { generatePageTitle } from 'utils/generateAppDefaults'

function ChatSupportPage() {
  const isFrontEnabled = useFeatureFlag('fmsFrontChat')
  const { boot, show } = useChatWidgetContext()

  // Opens the Front/Intercom widget when ready
  useEffect(() => {
    if (isFrontEnabled) {
      boot({
        shouldShowWindowOnLaunch: true,
        shouldHideCloseButton: true,
        isMobileWebview: true,
      })
    } else {
      // Intercom does not allow for opening the chat widget window on launch,
      // so we need to call the show method manually.
      setTimeout(() => {
        show()
      }, 1000)
    }
  }, [isFrontEnabled])

  return <DocumentTitle title={generatePageTitle('Support Chat')} />
}

export default ChatSupportPage
